import React, { useState, useEffect, useRef } from "react";
import { MSG } from "../constants/toastMessages";
import { toast } from 'react-toastify';
import { apiCallingPost } from "../api/services";
import RegexPattern from "../utils/regexPattern";
import { useNavigate } from 'react-router-dom';


function ForgotPassword(props) {
    const navigate = useNavigate();
    const [emailId, setemailId] = useState("");
    const [saveFlag, setSaveFlag] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const wrapperRef = useRef(null);

    useEffect(() => {
      
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowSearch(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []); 
  
      const handleForgotPasswordForm = async (e) => {
        e.preventDefault();
        if (!emailId || !RegexPattern.Email.test(emailId)) {
            toast.error(MSG.emailInvalid);
            document.getElementById("emailId").focus();
            return;
        }
        try {
            setSaveFlag(true);
            const postData = {
                emaild: emailId
            }
            const data = await apiCallingPost("api/authentication/forgotPassword", postData);
            if (data.data.success === "1") {
                // Neutral message — do not reveal whether the address is registered.
                toast.success(MSG.resetLinkSent)

            } else {
                toast.error(data.data.errorMessage);
            }
        } catch (error) {
            console.error("🚀 ~ forgotpassword ~ error:", error);
            toast.error(MSG.resetLinkFailed);
        } finally {
            setSaveFlag(false);
        }
    };








    return (
        <>
            <div className="right_login">
                <div className="right_login_inner">
                    <h2 className="right_loginhead">Forgot Password</h2>
                    {/* <div className="py-3 signup-sub-text">
            Sign up now and get access to exclusive content!
          </div> */}
                    <form onSubmit={handleForgotPasswordForm}>
                        <div className="form_div">
                            <input
                                type="email"
                                id="emailId"
                                placeholder="Email Id"
                                aria-label="Email address"
                                autoComplete="email"
                                value={emailId}
                                onChange={(e) => setemailId(e.target.value)}
                                className="form_login"
                            />
                        </div>



                        <p className="forgot-pwd-sec text-end">
                            <span className="signup-text">
                                {/* Already Registered?{" "} */}
                                <span className="ms-2 cursor-pointer" onClick={() => props.setForgotPassword(false)}>
                                    Back to Sign In
                                </span>
                            </span>
                        </p>

                        <button
                            type="submit"
                            disabled={saveFlag}
                            className="login_btn"
                        >
                            {"Submit"}
                            {/* {saveFlag ? "Signing Up..." : "Sign Up"} */}
                        </button>
                    </form>

                    <div className="copyright">
                        © {new Date().getFullYear()} Visit Qatar. All rights reserved.
                    </div>
                </div>
            </div>


        </>
    );
}

export default ForgotPassword;
